import React from "react";
import Flx from "../layout/Flx";
import SearchInput from "../inputs/SearchInput";
import { grey } from "@mui/material/colors";
import AgGridTableWrapper from "./AgGridTableWrapper";

const AgGridSearchableTableWrapper = ({
  children,
  endContent,
  quickFilter,
  setQuickFilter,
  tableSx,
  hideSearch = false,
  rowData,
  sx,
}) => {
  return (
    <Flx
      column
      sx={{
        p: 0,
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        overflow: "hidden",
        ...sx,
      }}
    >
      {hideSearch ? null : (
        <Flx
          wrap
          fw
          jb
          ac
          gap={2}
          sx={{
            p: 2,
            background: grey[100],
            borderBottom: "1px solid #e0e0e0",
            // borderTop: "1px solid #e0e0e0",
          }}
        >
          <SearchInput
            fullWidth
            value={quickFilter}
            sx={{ flexBasis: "400px", flexGrow: 1, background: "#ffffff" }}
            onChange={(e) => setQuickFilter(e)}
          />
          {endContent}
        </Flx>
      )}
      <AgGridTableWrapper
        simpleTable
        sx={{ tableSx }}
        suppressMinHeightWhenPopulated={rowData}
      >
        {children}
      </AgGridTableWrapper>
    </Flx>
  );
};

export default AgGridSearchableTableWrapper;
